"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Component2 = _interopRequireDefault(require("../../Component"));

var _react = _interopRequireDefault(require("react"));

var _snack = _interopRequireDefault(require("../templates/snack"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _theme = _interopRequireDefault(require("../../theme"));

var Snack =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Snack, _Component);

  function Snack(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Snack);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Snack).call(this, props));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "template", _snack["default"]);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "close", function () {
      clearTimeout(_this.closeTimeout);
      var _this$props = _this.props,
          onClose = _this$props.onClose,
          id = _this$props.id;

      if (typeof onClose === 'function') {
        onClose(id);
      }
    });
    _this.closeTimeout = setTimeout(_this.close, props.timeout);
    _this.ref = _react["default"].createRef();
    return _this;
  }

  (0, _createClass2["default"])(Snack, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
          setSnackHeight = _this$props2.setSnackHeight,
          id = _this$props2.id;

      if (typeof setSnackHeight === 'function' && this.ref && this.ref.current) {
        setSnackHeight(id, this.ref.current.offsetHeight);
      }
    }
  }]);
  return Snack;
}(_Component2["default"]);

(0, _defineProperty2["default"])(Snack, "displayName", 'Snack');
(0, _defineProperty2["default"])(Snack, "propTypes", {
  primary: _propTypes["default"].bool,
  warning: _propTypes["default"].bool,
  error: _propTypes["default"].bool,
  bottom: _propTypes["default"].bool,
  right: _propTypes["default"].bool,
  top: _propTypes["default"].bool,
  left: _propTypes["default"].bool,
  closeAvailable: _propTypes["default"].bool,
  open: _propTypes["default"].bool,
  timeout: _propTypes["default"].number,
  id: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  message: _propTypes["default"].string,
  height: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  offset: _propTypes["default"].number,
  screenX: _propTypes["default"].number,
  screenY: _propTypes["default"].number,
  onMoveEnd: _propTypes["default"].func,
  onHideEnd: _propTypes["default"].func,
  onClose: _propTypes["default"].func,
  setSnackHeight: _propTypes["default"].func,
  render: _propTypes["default"].func
});
(0, _defineProperty2["default"])(Snack, "defaultProps", {
  primary: false,
  warning: false,
  error: false,
  closeAvailable: true,
  message: '',
  height: ''
});

var _default = (0, _theme["default"])(Snack, 'snackBar');

exports["default"] = _default;